<template>
  <div class="content">
    <div class="content_middle">
      <span class="content_middle_title page_color_1C2438"
        >现场照片<span class="middle_titl_tip">请注意选择高清原图</span></span
      >
      <!-- <span class="middle_titl_tip">请注意选择高清原图</span> -->
      <ul>
        <li class="license-hold" id="licenseHold_hanhua">
          <input
            id="uploaderInputFour"
            class="input uploaderInputFour"
            type="file"
            accept="image/*"
            @change="showPositiveImage"
          />
          <img
            :src="holdBusinessPic"
            v-if="holdBusinessPic"
            style="position: absolute;top: 0;left: 0;width: 216px;height:142px"
          />
        </li>
        <p class="newInstruction">上传手持营业执照/企业门头照片 (选传1种)</p>
      </ul>
      <!-- <p class="instruction_size">
        营业执照文字清晰，门头名称含营业执照名称所有关键字
      </p> -->
      <p class="instruction_size">
        1.借款人本人双手持营业执照 (营业执照文字清晰)
      </p>
      <p class="instruction_size">
        2.企业或个体工商户门头照片 (门头文字含营业执照名称所有关键字)
      </p>
      <p class="instruction_size warmPrompt">
        温馨提示：不按照要求提供，将会导致无法放款
      </p>
    </div>
    <div class="attentionBox">
      <p class="title">注意事项</p>
      <div class="imgBox">
        <div class="standard">
          <img src="@/assets/images/bz@2x.png" alt="" />
          <span class="imgText "> <i class="yes"></i> 标准</span>
        </div>
        <div class="noHand">
          <img src="@/assets/images/nohandle@2x.png" alt="" />
          <span class="noHandText imgText "><i class="no"></i>没有手持</span>
        </div>
        <div class="noPortrait">
          <img src="@/assets/images/noPortrait@2x.png" alt="" />
          <span class="imgText "><i class="no"></i>人像不全</span>
        </div>
        <div class="fuzzy">
          <img src="@/assets/images/fuzzy@2x.png" alt="" />
          <span class="imgText "><i class="no"></i>照片模糊</span>
        </div>
      </div>
    </div>
    <div class="btnBox">
      <a href="javascript:;" class="btn" @click="submit">下一步</a>
    </div>
  </div>
</template>
<script>
// import { stringify } from 'querystring';
import { Toast } from 'vant';
import service from '@/request/api'; // 导入api接口
import { checkStatus } from './mixin';

export default {
  name: 'identityAuthentication',
  data() {
    return {
      negative: '',
      holdBusinessPic: '',
    };
  },
  mixins: [checkStatus],
  methods: {
    showPositiveImage(e) {
      const self = this;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const file = files[0]; // File对象
      this.negative = file;
      if (this.validate_img(files[0])) {
        // eslint-disable-next-line prefer-destructuring
        self.uploadFile = files[0];
        const reader = new FileReader(); // FileReader对象
        reader.readAsDataURL(files[0]); // 该方法会读取指定的 Blob 或 File 对象。读取操作完成的时候，readyState 会变成已完成（DONE），并触发 loadend 事件，同时 result 属性将包含一个data:URL格式的字符串（base64编码）以表示所读取文件的内容。
        reader.onload = (item) => {
          self.holdBusinessPic = item.target.result; // 图片内容的base64编码
          console.log(self.positive);
        };
      }
    },
    validate_img(file) {
      if (!/.(jpg|png|jpeg)$/i.test(file.name)) {
        Toast('请上传正确格式的个人头像');
        return false;
      }
      if (file.size.toFixed(5) >= 5 * 1024 * 1024) {
        Toast('请上传小于5M的图片');
        return false;
      }
      return true;
    },
    jumpThirdFc(orderId) {
      service.CommonForms.jumpThirdServer({ orderId }).then((res) => {
        if (res.success) {
          if (res.data) {
            window.location.href = res.data;
          }
        } else {
          Toast(res.returnMessage);
        }
      });
    },
    submit() {
      if (!this.holdBusinessPic) {
        Toast({
          message: '请上传手持营业执照/企业门头照片',
          position: 'top',
        });
        return;
      }
      if (this.holdBusinessPic) {
        const { orderId } = this.$store.state.commonForms;
        const form = new FormData();
        form.append('orderId', orderId || localStorage.getItem('orderId'));
        form.append('busiImage', this.negative);
        service.CommonForms.uploadBusiImageServer(form).then((res) => {
          if (res.success) {
            this.jumpThirdFc(orderId);
          } else {
            Toast(res.returnMessage || '上传失败');
          }
        });
      }
    },
  },
};
</script>
<style scoped>
/* 身份认证 */
body {
  background-color: #f8f8f9;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.content_middle {
  box-sizing: border-box;
  padding: 0 0.15rem 0.15rem 0.15rem;
  background: #fff;
}

.content_middle_title {
  margin: 0;
  padding: 13px 0;
  font-size: 17px;
  text-align: left;
}

.content_middle ul {
  text-align: center;
  background: #fff;
}

.content_middle ul li {
  position: relative;
  box-sizing: border-box;
  width: 216px;
  height: 142px;
  margin: 0 auto;
  overflow: hidden;
}

.content_bottom {
  margin-top: 0.08rem;
  padding: 0 0.15rem;
}

.btnBox {
  box-sizing: border-box;
  width: 100%;
  margin-top: 0.2rem;
  margin-bottom: 0.35rem;
  padding: 0 15px;
}

.btn {
  display: block;
  width: 100%;
  height: 44px;
  padding: 0;
  color: #fff;
  font-size: 17px;
  line-height: 44px;
  text-align: center;
  background-image: linear-gradient(-180deg, #f5514a 2%, #f5683c 99%);
  border-radius: 4px;
}

/* 文字颜色 */
.page_color_F65249 {
  color: #ff6538;
}

.page_color_A1A9B6 {
  color: #a1a9b6;
}

.page_color_A5ADB9 {
  color: #a5adb9;
}

.page_color_1C2438 {
  color: #1c2438;
}

.fs_bg {
  background: url('~@/assets/images/back.png') center center;
  background-size: cover;

  /* border: 1px dashed #979797; */
  border-radius: 0.08rem;
}

.se_bg {
  margin-top: 0.08rem;
  background: url('~@/assets/images/positive.png') center center;
  background-size: cover;
  border-radius: 0.08rem;
}

.mgt_15 {
  margin-top: 0.15rem;
}

.mgb_15 {
  margin-bottom: 0.15rem;
}

.mgt_8 {
  margin-top: 0.08rem;
}

/* input */
.input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.instruction {
  color: #838d9b;
  font-size: 13px;
}
.fl {
  float: left;
}

.fr {
  float: right;
}

.content_middle_title {
  display: block;
  padding: 0.17rem 0;
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 15px;
  font-size: 0.17rem;
  font-size: 17px;
}
.middle_titl_tip {
  padding-left: 5px;
  color: #9ea7b4;
  font-size: 12px;
  font-family: PingFangSC-Regular;

  /* display: block; */

  /* position: relative;
  top: -23px;
  left: -63px; */
}

.content_middle ul {
  padding-top: 10px;
  padding-right: 0.64rem;
  padding-bottom: 15px;
  padding-left: 0.64rem;
  background: #fff;
}

.content_middle ul li {
  /* width: 100%; */

  /* height: 1.425rem; */
  box-sizing: border-box;
}

.content_bottom {
  margin-top: 0.08rem;
  padding: 0 0.15rem;
}

.btnBox {
  box-sizing: border-box;
  width: 100%;
  margin-top: 0.2rem;
  margin-top: 34px;
  margin-bottom: 0.35rem;
  margin-bottom: 34px;
  padding: 0 0.15rem;
  padding-right: 15px;
  padding-left: 15px;
}

.btn {
  display: block;
  width: 100%;
  padding: 0.1rem 0;
  color: #fff;
  text-align: center;
  background-image: linear-gradient(-180deg, #f5514a 2%, #f5683c 99%);
  border-radius: 0.08rem;
  border-radius: 4px;
}

/* 文字颜色 */
.page_color_F65249 {
  color: #ff6538;
  font-family: PingFangSC-Regular;
}

.page_color_A1A9B6 {
  color: #a1a9b6;
  font-family: PingFangSC-Regular;
}

.page_color_A5ADB9 {
  color: #a5adb9;
  font-family: PingFangSC-Regular;
}

.page_color_1C2438 {
  color: #1c2438;
  font-family: PingFangSC-Medium;
}

.fs_bg {
  background: url('~@/assets/images/back.png') center center;
  background-size: cover;

  /* border: 1px dashed #979797; */
  border-radius: 0.08rem;
}

.se_bg {
  margin-top: 0.08rem;
  background: url('~@/assets/images/positive.png') center center;
  background-size: cover;

  /* border: 1px dashed #979797; */
  border-radius: 0.08rem;

  /* width: 2.16rem; */
}
.license {
  margin-top: 0.08rem;
  background: url('~@/assets/images/license.png') center center;
  background-size: cover;

  /* border: 1px dashed #979797; */
  border-radius: 0.08rem;
}
.license-hold {
  margin-top: 0.08rem;
  background: url('~@/assets/images/licenseHold.png') center center;
  background-size: cover;

  /* border: 1px dashed #979797; */
  border-radius: 0.08rem;
}

/* 文字大小 */
.page_fs_14 {
  font-size: 0.14rem;
}

.weui-popup__modal div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}

.weui-popup__modal div img {
  margin-top: 30px;
}
.instruction {
  margin: 0;
  padding: 0;
  color: #838d9b;
  font-size: 0.13rem;
  letter-spacing: 0;
  text-align: center;
}
.newInstruction {
  margin-top: 10px;
  margin-bottom: 0;
  color: #838d9b;
  font-size: 0.13rem;
  letter-spacing: 0;
  text-align: center;
}
.instruction_size {
  /* white-space: nowrap; */
  padding-top: 0;
  padding-right: 15px;
  padding-bottom: 0;
  padding-left: 30px;
  color: #a7afbb;
  font-size: 0.09rem;
  text-align: left;
}
.mt5 {
  margin-top: 5px;
}
.warmPrompt {
  padding-bottom: 20px;
}
.attentionBox {
  background: #fff;
}
.attentionBox .title {
  margin-top: 10px;
  padding-top: 13px;
  padding-left: 15px;
  color: #1c2438;
  font-size: 17px !important;
  font-family: PingFangSC-Medium;
  text-align: left;
}
.imgBox {
  min-height: 90px;
  padding-right: 15px;
  padding-left: 15px;
}
.imgBox > div {
  float: left;
  width: 23%;
  min-height: 90px;

  /* padding-right: 16px; */

  /* padding-left: 0; */
}
.noHand {
  padding-right: 2.5%;
  padding-left: 2.5%;
}
.noPortrait {
  padding-right: 2.5%;
}

/* .fuzzy {
  padding-right: 0 !important;
  padding-left: 14px !important;
} */
.imgBox > div > img {
  width: 100%;
}
.imgText {
  /* padding-right: 5px; */
  display: inline-block;
  width: 100%;
  color: #838d9b;
  font-size: 12px;
  text-align: center;
}
.yes {
  display: inline-block;
  width: 10px;
  height: 10px;

  /* padding-right: 10px; */
  background: url('~@/assets/images/yes@2x.png') no-repeat center center;
  background-size: 13px;
}
.no {
  display: inline-block;
  width: 10px;
  height: 10px;
  padding-right: 7px;
  background: url('~@/assets/images/cloase@2x.png') no-repeat center center;
  background-size: 13px;
}
</style>
